<template>
  <div class="outer-div">
      <div>
        <v-form
          ref="form"
          v-model="valid"
        >
            <v-text-field
              v-model="mobile"
              label="Mobile Number*"
              light
              required
              outlined
            />

          <p
            class="text-center grey--text"
          >
            OR
          </p>

          <v-text-field
            v-if="getCurrentSelectedUserType === 'staff'"
            v-model="email"
            label="Employee Id*"
            light
            required
            outlined
          />

          <v-text-field
            v-else
            v-model="email"
            label="Email Address*"
            light
            required
            outlined
          />
        </v-form>
      </div>
      <div class="btn-container">
        <v-btn color="orange darken-3" x-large block dark
          class="rounded-xl"
          :disabled="isSubmitDisabled"
          @click.prevent="checkForMobile()"
          >
          Search
        </v-btn>
      </div>
  </div>
</template>
<script>
import axios from '@/app-axios'

export default {
  name: 'ExistingCustomerCheck',

  data: () => ({
    valid: false,
    email: '',
    mobile: '',
    employeeId: '',
    errorResponse: ''
  }),

  computed: {
    getCurrentSelectedUserType () {
      return this.$store.getters['decision/getCustomerType']
    },
    hasEmptyFields () {
      return this.email.trim() === '' &&
         this.mobile.trim() === '' &&
         this.employeeId.trim() === ''
    },
    isSubmitDisabled () {
      return this.hasEmptyFields
    }
  },

  methods: {
    checkForMobile () {
      this.$store.dispatch('swiftuser/onNewUserMobile', this.mobile)
      const config = {
        headers: {
          'x-organization-id': this.$store.getters['swiftuser/getOrganizationId'],
          'x-digi-board-id': this.$store.getters['swiftuser/getDigiBoardId']
        }
      }
      axios.get('api/swift-checkin/search/' + this.mobile, config).then(response => {
        if (response.status === 200) {
          this.$store.dispatch('swiftuser/onAddUser', response.data)
          this.$emit('stepSuccess')
        }
      }).catch(error => {
        this.errorResponse = error.response.data.errors
        this.$store.dispatch('swiftuser/onAddUser', {})
        this.$emit('stepSuccess')
      })
    }
  }
}
</script>
<style lang="css" scoped>
.outer-div {
  margin-top: 10px;
  height: 100%;
}
</style>
